<template>
  <div class="rootTable">
    <div style="float: left;margin-left:-0.5rem;margin-top:-0.5rem;padding-left:0.5rem;padding-top:0.5rem;width: 100%">
      <div style="float:left;margin-top: 0.2rem">
        <span style="font-size: 1.2rem">出生日期：</span>
      </div>
      <div style="float:left;margin-top: -0.5rem;">
        <Cell style="height: 0.8rem;padding: 0;margin: 0" :title="currentDate" is-link
              v-on:click.native="openDatePicker"></Cell>
      </div>
      <div style="float:left;margin-top: 0.35rem">
        <Checkbox v-model="lunarChecked" shape="square" icon-size="16px" :label-disabled=true>农历
          <template slot="icon" slot-scope="props">
            <img width="20px" height="20px" class="img-icon" style="margin-top: -0.1rem;margin-right: -0.2rem"
                 :src="props.checked ? activeIcon : inactiveIcon" alt=""/>
          </template>
        </Checkbox>
      </div>
      <div style="float:right;margin-top: 0;margin-bottom:0.2rem;margin-right: 0.5rem">
        <Button type="primary" size="small" @click="calculation">计算</Button>
      </div>
      <div style="background-color: gray;clear: both;margin-left: -1rem;">
        <Divider></Divider>
      </div>
    </div>
    <div style="clear: both;margin-right: -0.5rem;">
      <div style="text-align: left;" v-for="item in HolidayList" :key="item.year">
        <Span :style="{'color':item.year-currentYear<3&&item.year-currentYear>=0? 'red':'black'}">({{
            item.age
          }}岁) </Span>
        <Span :style="{'color':item.year-currentYear<3&&item.year-currentYear>=0? 'red':'black'}">{{
            item.year
          }} 年的 </Span>
        <Span :style="{'color':item.year-currentYear<3&&item.year-currentYear>=0? 'red':'green'}">{{
            item.name
          }}</Span>
        <Span :style="{'color':item.year-currentYear<3&&item.year-currentYear>=0? 'red':'black'}"> 是你的生日</Span>
      </div>
    </div>
    <DatetimePicker
        ref="date_picker"
        type="date"
        :startDate="startDate"
        :endDate="endDate"
        year-format="{value} 年"
        month-format="{value} 月"
        date-format="{value} 日"
        v-model="tempDate" @confirm="DateConfirm">
    </DatetimePicker>
  </div>
</template>

<script>
import {DatetimePicker, Cell, Indicator} from "mint-ui";
import {Checkbox, Button, Divider} from 'vant';
import 'vant/lib/checkbox/index.css'
import 'vant/lib/button/index.css'
import 'vant/lib/divider/index.css'

export default {
  name: "BirthdayHoliday",
  components: {
    DatetimePicker, Cell, Checkbox, Button, Divider
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      lunarChecked: false,
      currentDate: null,
      tempDate: null,
      HolidayList: [],
      startDate: new Date("1901-01-01"),
      endDate: new Date(),
      activeIcon: require('../../../assets/images/32/selected.png'),
      inactiveIcon: require('../../../assets/images/32/not_selected.png'),
      calculationBirthdayUrl: '/api/business/calculationBirthday',
      token: localStorage.getItem('token'),
    }
  },
  mounted() {
    if (this.$route.params.dateType !== undefined) {
      this.currentDate = this.$route.params.year + '-' + this.formatTen(this.$route.params.month) + '-' + this.formatTen(this.$route.params.day);
      this.lunarChecked = (this.$route.params.dateType === 'Lunar')
      this.calculation()
    } else {
      this.currentDate = '1990-01-01'
    }
  },
  methods: {
    calculation() {
      Indicator.open({
        text: '计算中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.calculationBirthdayUrl,
        params: {islunar: this.lunarChecked, birthday_string: this.currentDate},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        this.HolidayList = response.data['responseData']
        if (this.HolidayList.length === 0) {
          this.$messagebox.alert('很遗憾，从您出生到2100年，您的生日不与任何一个节日重合。')
        }
      }).catch(response => {
        Indicator.close()
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      });
    },
    openDatePicker() {
      if (this.currentDate != null)
        this.tempDate = this.currentDate
      this.$refs.date_picker.open();
    }
    ,
    DateConfirm() {
      this.currentDate = this.formatDate(this.tempDate)
    },
    //更改时间格式
    formatTen(num) {
      return num > 9 ? (num + "") : ("0" + num);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return year + '-' + this.formatTen(month) + '-' + this.formatTen(day);
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-divider {
  margin: 0;
}
</style>
